import { Storage } from '@frameio/utils';

export const assetsStorage = new Storage<{
  downloadPreference: 'transferApp' | 'browser' | 'driveApp';
}>();
